


import React from 'react';
import single from '../../assets/popup/question.png'
import errorGif from '../../assets/popup/close.gif'
function PopupConfirmation({ show, onClose, Message, msgtype , onCancel, 
  onSubmit  }) {
  if (!show) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <button className="popup-close" onClick={onClose}>×</button>
        
        <div className="blue-half-circle">
          <img src={single} alt="Popup Icon" className="popup-image" />
        </div>

        <div className="popup-content">
          <h4 style={{ color: '#823455' }}>{msgtype}</h4>
          <p>{Message}</p>
          <div className="popup-buttons">
           <button className="popup-btn cancel-btn" onClick={onCancel}>Cancel</button>
            <button className="popup-btn submit-btn" onClick={onSubmit}>Submit</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PopupConfirmation;
